
// page load event
window.addEventListener("DOMContentLoaded", function () {
  window.dataLayer = window.dataLayer || [];
  function trackEvent(eventName, element, extraData = {}) {
      let eventData = {
          'event': eventName,
          'page_referrer': document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
          'locale': document.documentElement.lang || "en",
          'device.category': navigator.userAgent.includes("Mobi") ? "mobile" : "desktop",
          'utm': new URLSearchParams(window.location.search).get("utm_source") || "direct",
          'timestamp': new Date().toISOString(),
          'gtm.uniqueEventId': new Date().getTime(),    
          'page_location': window.location.href,
          'page_path': window.location.pathname,
          'page_referrer': document.referrer || 'direct',
          ...extraData
      };
      window.dataLayer.push(eventData);
  }
  const product_data = document.querySelector(".custom_page_load");
  const product_name = product_data.getAttribute('data-product-name')
  const product_category = product_data.getAttribute('data-product-category');
  const product_price = product_data.getAttribute('data-product-price');
  const collection_name = product_data.getAttribute('data-collection-name');
  document.body.addEventListener('click', function (e) {
    const clickedElement = e.target;
    const target = clickedElement.closest('[data-track-click], figure, a, button, div, span, summary, img, h1, p, input, td, th');
    if (!target) return;
  
    const isImage = clickedElement.tagName === 'IMG';
    const linkedElement = isImage ? clickedElement.closest('a') : null;
    const linkedHref = linkedElement ? linkedElement.href : 'No Link';
  
    const shopifySectionParent = clickedElement.closest('[id^="shopify-section-"], [id^="section-"], [data-section-id]');
    const shopifySectionId = shopifySectionParent ? shopifySectionParent.id : 'No Section ID';
  
    // Get the closest ancestor with a class or id if the target doesn't have it
    const getClosestWithAttr = (element, attr) => {
      while (element && !element.getAttribute(attr)) {
        element = element.parentElement;
      }
      return element ? element.getAttribute(attr) : '';
    };
  
    const fallbackClass = target.className || getClosestWithAttr(target, 'class');
    const fallbackId = target.id || getClosestWithAttr(target, 'id');
  
    // Shopify section child class (within the section)
    let shopifySectionChildClass;
    if (shopifySectionParent) {
      const allDescendantsWithClass = shopifySectionParent.querySelectorAll('[class]');
      for (const element of allDescendantsWithClass) {
        if (element.contains(clickedElement)) {
          shopifySectionChildClass = element.className;
          break;
        }
      }
    }
  
    // Smarter click text detection
    const getClickText = (el) => {
      return el.textContent?.trim().slice(0, 100) ||
        el.getAttribute('aria-label') ||
        el.getAttribute('alt') ||
        el.getAttribute('title') ||
        'Unknown';
    };
  
    const eventData = {
      event: 'ANALYTICS_CLICK',
      click_text: isImage ? `Image Source: ${clickedElement.src}` : getClickText(target),
      click_id: fallbackId,
      click_class: fallbackClass,
      ...(shopifySectionChildClass && { shopify_section_child_class: shopifySectionChildClass }),
      ...(product_name && { product_name }),
      ...(product_category && { product_category }),
      ...(product_price && { product_price }),
      page_host: window.location.host,
      page_path: window.location.pathname,
      page_location: window.location.href,
      page_referrer: document.referrer || "direct",
      locale: navigator.language || "EN",
      device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
      utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
      timestamp: new Date().toISOString()
    };
  
    window.dataLayer.push(eventData);
  });

  //page laod event
  window.dataLayer.push({  // Done as per data layer
    event: "customPageLoad",
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_referrer: document.referrer || "direct",
    locale: navigator.language || "EN",
    device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
    utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
    timestamp: new Date().toISOString(),
    ...(product_name && { product_name: product_name }),
    ...(product_category && { product_category: product_category }),
    ...(product_price && { product_price: product_price })
  });
  // Hamburger menu click
  const hamburger = document.querySelector('.header__mobile__hamburger');
  hamburger.addEventListener("click", function () {
  window.dataLayer.push({ // Done as per data layer
      event: "HAMBURGER_CLICK",
      click_label: "Mobile Menu Toggle",
      page_path: window.location.pathname,
      page_referrer: document.referrer || 'direct',
      page_location: window.location.href,
      ...(product_name && { product_name: product_name }),
      ...(product_category && { product_category: product_category }),
      ...(product_price && { product_price: product_price })
  });
  console.log("🍔 Hamburger menu click tracked in dataLayer.");
  });
  //scrollDepth
  let maxScroll = 0;
  let maxScrollOnPage = 0;

  let inactivityTimer;
  const isProductPage = window.location.pathname.includes('/products/');
  window.addEventListener("scroll", function () {
      const scrollTop = window.scrollY || document.documentElement.scrollTop; ;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.floor((scrollTop / docHeight) * 100);
      if (scrollPercent > maxScroll) {
      maxScroll = Math.max(1, Math.min(scrollPercent, 100)); ;
      }
  });
  monitorScrollAndActivity();

  function getScrollPercent() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    let scrollPercent = Math.round((scrollTop / docHeight) * 100);
    // Ensure it's always between 1 and 100
    scrollPercent = Math.max(1, Math.min(scrollPercent, 100));
    return scrollPercent;
  }

  function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(function () {
      // Ensure maxScroll is also clamped before sending
      let safeScroll = Math.max(1, Math.min(maxScrollOnPage, 100));

      console.log("SCROLL_ON_PAGE" , safeScroll);
      window.dataLayer.push({
        event: 'SCROLL_ON_PAGE',
        maxScrollPercent: safeScroll,
        page_referrer: document.referrer || "direct",
        locale: navigator.language || "EN",
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        page_location: window.location.href,
        page_path: window.location.pathname,
        ...(product_name && { product_name: product_name }),
        ...(product_category && { product_category: product_category }),
        ...(product_price && { product_price: product_price })
      });
    }, 10000); // 10 seconds of inactivity
  }

  function monitorScrollAndActivity() {
    window.addEventListener('scroll', function () {
      const currentScroll = getScrollPercent();
      if (currentScroll > maxScrollOnPage) {
        maxScrollOnPage = currentScroll;
      }
      resetInactivityTimer();
    });

    ['mousemove', 'click', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, resetInactivityTimer);
    });
  }

  // Menu Click
  document.querySelectorAll('.menu__item a[data-top-link]').forEach(menuLink => {
      menuLink.addEventListener('click', function () {
      window.dataLayer.push({  // Done as per data layer
          event: "MENU_CLICK",
          referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
          collection_name: menuLink.innerText.trim() || "Unknown",
          click_destination: menuLink.href.includes("/collections/") ? "collection_page" : "other",
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          locale: navigator.language || "EN",
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),         
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price })
      });
      });
  });
  // Trend Slide Click
  document.querySelectorAll(".gtm-product-event").forEach(trendSlide => {
    trendSlide.addEventListener('click', function () { 
      const trendName = trendSlide.getAttribute("data-title") || "Unknown Trend";
      const product_name = trendSlide.getAttribute("data-name") || "Unknown Product";
      const product_price = trendSlide.getAttribute("data-price") || "N/A";
      const product_category = trendSlide.getAttribute("data-category") || "Uncategorized";
      window.dataLayer.push({ // Done as per data layer
          event: "TREND_CLICK", 
          referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
          locale: navigator.language || "EN",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          product_name: product_name,
          product_price: product_price,
          product_category: product_category
      });
    });
  });
  // Category Click
  document.querySelectorAll("a.reel_inner").forEach(categoryBtn => {
      categoryBtn.addEventListener('click', function () {
          const categoryBtn_link = categoryBtn.getAttribute('href') || '';
          window.dataLayer.push({ // Done as per data layer
              event: "CATEGORY_CLICK",
              category_name: categoryBtn.textContent.trim(),
              page_location: window.location.href,
              page_referrer: document.referrer || "direct",
              locale: navigator.language || "EN",
              device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
              utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
              timestamp: new Date().toISOString(),
              ...(product_name && { product_name: product_name }),
              ...(product_category && { product_category: product_category }),
              ...(product_price && { product_price: product_price })
          });
      });
  });
  // Profile Click
  document.querySelectorAll("a[href*='/account']").forEach(accountBtn => {
    accountBtn.addEventListener('click', function () {
      const isLogin = accountBtn.classList.contains("login_acc");
      const eventData = {
        event: isLogin ? "SIGNUP_CLICK" : "account_click",
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        locale: navigator.language || "EN",
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
        ...(product_name && { product_name: product_name }),
        ...(product_category && { product_category: product_category }),
        ...(product_price && { product_price: product_price })
      };

      window.dataLayer.push(eventData);
    });
  });
  document.addEventListener("submit", function(event) {
    const signupForm = event.target.closest("form[action*='/account']");
    const loginForm = event.target.closest("form[action*='/account/login']");
    const emailInput = document.querySelector("input[type='email']");
    const email = emailInput ? emailInput.value.trim() : "N/A";
    localStorage.setItem('email', email);
    // Handle SIGNUP
    if (signupForm && window.location.href == 'https://hyoufinejewelry.com/account/register') {
      setTimeout(() => {
        const errorElement = document.querySelector(".errors");
        const isSuccess = window.location.pathname.includes("/account/register");
        if (!isSuccess) {
          // SIGNUP_SUCCESS
          window.dataLayer.push({
            event: "SIGNUP_SUCCESS",
            email: email,
            type: "email",
            locale: navigator.language || "EN",
            utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
            timestamp: new Date().toISOString(),
            device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
            page_path: window.location.pathname,
            page_location: window.location.href,
            page_referrer: document.referrer || "direct",
            referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
            ...(product_name && { product_name: product_name }),
            ...(product_category && { product_category: product_category }),
            ...(product_price && { product_price: product_price })
          });
        }
        else {
          // SIGNUP_FAILURE
          const reason = errorElement?.innerText.includes("email") ? "wrong email"
                        : errorElement?.innerText.includes("password") ? "wrong password"
                        : "other";
          const attemptCount = parseInt(localStorage.getItem("signup_attempts") || "0", 10) + 1;
          localStorage.setItem("signup_attempts", attemptCount);
          const stored_email = localStorage.getItem('email');
          window.dataLayer.push({
            event: "SIGNUP_FAILURE",
            email: stored_email,
            type: "email",
            attempt_count: attemptCount,
            reason: reason,
            locale: navigator.language || "EN",
            utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
            timestamp: new Date().toISOString(),
            device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
            page_path: window.location.pathname,
            page_location: window.location.href,
            page_referrer: document.referrer || "direct",
            referrer: getReferrerSource()
          });
        }
      }, 1500);
    }
    // Handle LOGIN
    if (loginForm && window.location.href == 'https://hyoufinejewelry.com/account/login') {
      const stored_email = localStorage.getItem('email');
      setTimeout(() => {
        const isSuccess = window.location.pathname.includes("/account");
        if (isSuccess) {
          // LOGIN_SUCCESS
          window.dataLayer.push({
            event: "LOGIN_SUCCESS",
            email: email,
            type: "email",
            locale: navigator.language || "EN",
            utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
            timestamp: new Date().toISOString(),
            device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
            page_path: window.location.pathname,
            page_location: window.location.href,
            page_referrer: document.referrer || "direct",
            referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct"
          });
        } 
        else {
          // LOGIN_FAILURE
          const passwordInput = loginForm.querySelector("input[type='password']");
          const password = passwordInput ? passwordInput.value.trim() : "";
          const attemptCount = parseInt(localStorage.getItem("login_attempts") || "0", 10) + 1;
          const reason = email === "" ? "wrong email"
                        : password === "" ? "wrong password"
                        : "invalid credentials";
          window.dataLayer.push({
            event: "LOGIN_FAILURE",
            email: stored_email,
            type: "email",
            reason: reason,
            attempt_count: attemptCount,
            locale: navigator.language || "EN",
            utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
            timestamp: new Date().toISOString(),
            device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
            page_path: window.location.pathname,
            page_location: window.location.href,
            page_referrer: document.referrer || "direct",
            referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
          });
        }
      }, 1500);
    }
  });
  const forgot_pass = this.document.querySelector('.forgot-password button[data-show-reset]');
  if (forgot_pass) {
    forgot_pass.addEventListener('click', function () { 
      window.dataLayer.push({ // done as per data layer
        event: "FORGOT_PASSWORD",
        reset_method:'email',
        reset_status:'initiated',
        locale: navigator.language || "EN",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
        ...(product_name && { product_name: product_name }),
        ...(product_category && { product_category: product_category }),
        ...(product_price && { product_price: product_price })
      });
    });
  }
  // plp filter click SORTBY_CLICK
  const sort_click = document.querySelector(".popout--sort");
  if(sort_click){
    sort_click.addEventListener("click", function(event) {
      const filterElement = document.querySelector('.popout__toggle span.popout__toggle__text[data-sort-button-text]') || document.querySelector('.popout__toggle span.popout__toggle__text');
      if (filterElement) {
        const filterLabel = filterElement.innerText.trim();
        window.dataLayer.push({
          event: "SORTBY_CLICK",
          locale: navigator.language || "EN",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          //referrer: document.referrer.includes("google") ? "google" : document.referrer.includes("facebook") ? "meta" : "direct",
          filter_type: filterLabel || 'Sort by'
        });
      }
    });
  }
  // fliter track
  const fliter_click = document.querySelector(".popout--group");
  if(fliter_click){
    fliter_click.addEventListener("click", function(event) {
      const filterLabel = fliter_click.querySelector('.popout__toggle')?.innerText?.trim();
       if (filterLabel) {
        window.dataLayer.push({
          event: "FILTER_CLICK",
          locale: navigator.language || "EN",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          filter_type: filterLabel || 'Show Filters',
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price }),
         
        });
      }
    });
  }
  //  * cart events *  //
  // Cart Click
  // document.querySelectorAll("a.navlink--cart--icon").forEach(cartBtn => {
  //     cartBtn.addEventListener('click', function () {
  //         const cartCountEl = document.querySelector(".header__cart__status[data-cart-count]");
  //         const cartItemCount = cartCountEl ? parseInt(cartCountEl.innerText, 10) || 0 : 0;        
  //         setTimeout(function(){
  //         const totalEl = document.querySelector(".docapp-cart-with-coupon-summary--summary .docapp-est-total span.docapp-right");
  //         const discountEl = document.querySelector(".docapp-cart-with-coupon-summary--summary .docapp-cart-discount span.docapp-right"); 
  //         const subtotalEl = document.querySelector(".docapp-cart-with-coupon-summary--summary .docapp-cart-subtotal span.docapp-right");  
  //         let subtotal = subtotalEl ? parseInt(subtotalEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;       
  //         let total = totalEl ? parseInt(totalEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
  //         const discount = discountEl ? parseInt(discountEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
  //         //const formatMoney = el => `$${parseFloat((el?.innerText || "0").replace(/[^0-9.]/g, "")) || 0}`;
  //         if(discount > 0){
  //           total = total
  //         }
  //         else {
  //           total = subtotal
  //         }
  //         window.dataLayer.push({ // Done as per data layer
  //           event: "CART_CLICK",
  //           cart_item_count: cartItemCount,
  //           locale: navigator.language || "EN",
  //           utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
  //           timestamp: new Date().toISOString(),
  //           device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
  //           page_path: window.location.pathname,
  //           page_location: window.location.href,
  //           page_referrer: document.referrer || "direct",
  //           cart_discount:discount,
  //           cart_total: total,
  //           ...(product_name && { product_name: product_name }),
  //           ...(product_category && { product_category: product_category }),
  //           ...(product_price && { product_price: product_price })
  //         });
           
  //        },1900)
  //    });
  // });  
   document.querySelectorAll("a[data-cart-toggle]").forEach(cartBtn => {
      cartBtn.addEventListener('click', function () {
        const cartCountEl = document.querySelector(".header__cart__status[data-cart-count]");
        let cart_value, cart_discount;
        const cartItemCount = cartCountEl ? parseInt(cartCountEl.innerText, 10) || 0 : 0; 
        fetch('/cart.js') // or '/cart.json'
        .then(response => response.json())
        .then(cart => {
          cart_value = cart.total_price / 100;
          cart_discount = cart.total_discount / 100;
          console.log("Cart Total:", cart_value);
          console.log("Cart Discount:", cart_discount);
             window.dataLayer.push({ // Done as per data layer
              event: "CART_CLICK",
              cart_item_count: cartItemCount,
              locale: navigator.language || "EN",
              utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
              timestamp: new Date().toISOString(),
              device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
              page_path: window.location.pathname,
              page_location: window.location.href,
              page_referrer: document.referrer || "direct",
              couponApplied:cart_discount,
              cart_value: cart_value,
              ...(product_name && { product_name: product_name }),
              ...(product_category && { product_category: product_category }),
              ...(product_price && { product_price: product_price })
            });
        })
        .catch(error => console.error("Error fetching cart:", error));
       
     });
  });  


  document.addEventListener('click', function (e) {
    const deleteButton = e.target.closest(".cart__item__remove");
    const plusButton = e.target.closest(".cart__quantity-plus");
    const minusButton = e.target.closest(".cart__quantity-minus");
  
    if (deleteButton) {
      e.preventDefault();
      const product_name = deleteButton.getAttribute('data-product-title') || "Unknown";
      const product_category = deleteButton.getAttribute('data-product-category') || "Uncategorized";
      const product_price = deleteButton.getAttribute('data-product-price') || "0";
  
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "DELETE_PRODUCT_CLICK",
        locale: navigator.language || "EN",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        product_name,
        product_price,
        product_category
      });
    }
  
    if (plusButton || minusButton) {
      e.preventDefault();
      const button = plusButton || minusButton;
      const quantityField = button.closest('.cart__quantity').querySelector('.cart__quantity-field');
      const currentQuantity = parseInt(quantityField.value, 10) || 0;
      const previousQuantity = plusButton ? currentQuantity - 1 : currentQuantity + 1;
      const product_name = button.getAttribute('data-product-title') || "Unknown";
      const product_category = button.getAttribute('data-product-category') || "Uncategorized";
      const product_price = button.getAttribute('data-product-price') || "0";
  
      window.dataLayer.push({
        event: "CHANGE_QUANTITY_CLICK",
        locale: navigator.language || "EN",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        product_name,
        product_price,
        product_category,
        current_qty: currentQuantity,
        previous_qty: previousQuantity
      });
    }
  });

  // cart drawer checkout event
  document.querySelectorAll(".cart__checkout").forEach(check_OutButton => {
    check_OutButton.addEventListener('click', function () {
      setTimeout(function () {
        const cartCountEl = document.querySelector(".header__cart__status[data-cart-count]");
        const cartItemCount = cartCountEl ? parseInt(cartCountEl.innerText.trim(), 10) || 0 : 0;
        const totalEl = document.querySelector(".docapp-cart-with-coupon-summary--summary .docapp-est-total span.docapp-right");
        const subtotalEl = document.querySelector(".docapp-cart-with-coupon-summary--summary .docapp-est-total span.docapp-right");
        const discountEl = document.querySelector(".docapp-cart-with-coupon-summary--summary .docapp-cart-discount span.docapp-right");
        // const total = totalEl ? totalEl.textContent.trim() : "0";
        // const discount = discountEl ? discountEl.textContent.trim() : "0";
        let subtotal = subtotalEl ? parseInt(subtotalEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
        let total = totalEl ? parseInt(totalEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
        const discount = discountEl ? parseInt(discountEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
        const couponEl = document.querySelector(".docapp-coupon-input--bean-container--bean");
        const couponApplied = discountEl ? parseInt(discountEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
        const couponCode = couponEl ? couponEl.textContent.trim() : "";
         if(discount > 0){
            total = total
          }
          else {
            total = subtotal
          }
        window.dataLayer.push({
          event: "CHECKOUT_CLICK",
          cart_item_count: cartItemCount,
          cart_value: total,
          locale: navigator.language || "EN",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          coupon_applied: couponApplied,
          coupon_code: couponCode,
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price })
        });
      }, 1000);
      
    });
  });
  // discount coupon code 
  const attachedButtons = new WeakSet();
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        const cupponBtn = document.querySelector(".docapp-coupon-input--button-text");
  
        // Only attach if the button exists and hasn't already been tracked
        if (cupponBtn && !attachedButtons.has(cupponBtn)) {
          console.log("Attaching click to coupon button");
  
          attachedButtons.add(cupponBtn); // Track that we added a listener
  
          cupponBtn.addEventListener('click', function () {
            setTimeout(function () {
              const cartCountEl = document.querySelector(".header__cart__status[data-cart-count]");
              const cartItemCount = cartCountEl ? parseInt(cartCountEl.innerText.trim(), 10) || 0 : 0;
              const subtotalEl = document.querySelector(".cart__foot .docapp-cart-with-coupon-summary--summary .docapp-est-total span.docapp-right");
              const totalEl = document.querySelector(".cart__foot .docapp-cart-with-coupon-summary--summary .docapp-est-total span.docapp-right");
              const discountEl = document.querySelector(".cart__foot .docapp-cart-with-coupon-summary--summary .docapp-cart-discount span.docapp-right");
              // const total = totalEl ? totalEl.textContent.trim() : "0";
              // const discount = discountEl ? discountEl.textContent.trim() : "0";
              let subtotal = subtotalEl ? parseInt(subtotalEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
              let total = totalEl ? parseInt(totalEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
              const discount = discountEl ? parseInt(discountEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
              const couponEl = document.querySelector(".docapp-coupon-input--bean-container--bean");
              const couponApplied = discountEl ? parseInt(discountEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
              const couponCode = couponEl ? couponEl.textContent.trim() : "";
              let cartValueBeforeEl = document.querySelector(".cart__foot .docapp-cart-with-coupon-summary--summary .docapp-cart-subtotal span.docapp-right");
              const cartValueBefore = cartValueBeforeEl ? parseInt(cartValueBeforeEl.textContent.replace(/[^0-9]/g, ''), 10) : 0;
               if(discount > 0){
                  total = total
                }
                else {
                  total = subtotal
                }
              window.dataLayer.push({
                event: "COUPON_APPLY_CLICK",
                cart_item_count: cartItemCount,
                cart_value: total,
                locale: navigator.language || "EN",
                utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
                timestamp: new Date().toISOString(),
                device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
                coupon_value: couponApplied,
                coupon_code: couponCode,
                cart_value_before: cartValueBefore,
                page_path: window.location.pathname,
                page_location: window.location.href,
                page_referrer: document.referrer || "direct",
                ...(product_name && { product_name: product_name }),
                ...(product_category && { product_category: product_category }),
                ...(product_price && { product_price: product_price })
              });
            }, 2000);
          });
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  //  * pdp events * 
  const subTitle = document.getElementById('subtitle_content');
  if(subTitle){
    subTitle.addEventListener('click', function () {
      const subtitleText = subTitle.textContent.trim();
      window.dataLayer.push({ // Done as per data layer
      event: "SUBTITLE_CLICK",
      click_text: subtitleText,
      click_id: subTitle.id || '',
      click_class: subTitle.className || '',
      page_path: window.location.pathname,
      page_location: window.location.href,
      page_referrer: document.referrer || "direct",
      locale: navigator.language || "EN",
      device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
      utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
      timestamp: new Date().toISOString(),
      ...(product_name && { product_name: product_name }),
      ...(product_category && { product_category: product_category }),
      ...(product_price && { product_price: product_price })
      });
    });
  }
  // size guide click
  const size_guide = document.querySelector('.ring_size_guide');
  if(size_guide){
    size_guide.addEventListener('click', function () {
        window.dataLayer.push({
          event: "SIZE_GUIDE",
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          locale: navigator.language || "EN",
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price })
        });
    });
  }
  //Share Click
  const shareBtn= document.querySelector(".sharing-button");
  if (shareBtn) {
      shareBtn.addEventListener('click', function () {
          window.dataLayer.push({ // Done as per data layer
              event: "SHARE_CLICK",
              page_path: window.location.pathname,
              page_location: window.location.href,
              page_referrer: document.referrer || "direct",
              locale: navigator.language || "EN",
              device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
              utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
              timestamp: new Date().toISOString(),
              ...(product_name && { product_name: product_name }),
              ...(product_category && { product_category: product_category }),
              ...(product_price && { product_price: product_price })
          });
      });
  }
  // Get all radio inputs inside .radio__buttons
  const sizeInputs = document.querySelectorAll('.radio__buttons .radio__button input[type="radio"]');
  if(sizeInputs && window.location.href.includes("/products/")) {
    function getCheckedSize() {
      const checkedInput = document.querySelector('.radio__buttons .radio__button input[type="radio"]:checked');
      const checkedInput_val = checkedInput ? checkedInput.value : '';
      if (checkedInput) {
      console.log("Checked size:", checkedInput.value);
      } else {
      console.log("No size selected.");
      }
    const cliked_id =  checkedInput ? checkedInput.getAttribute('id') || '' : ''
      window.dataLayer.push({
          event: "SIZE_CLICK",
          click_id: checkedInput_val || "N/A",
          click_class: sizeInputs.className || 'radio__button',
          selectedSizeInput:checkedInput_val || "N/A",
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          locale: navigator.language || "EN",
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price })
      });
    }
    //getCheckedSize();
    sizeInputs.forEach(input => {
        input.addEventListener('change', getCheckedSize);
    });
  }
  // Product Click hot right now
  document.querySelectorAll(".hot-right-now .product-images-curv").forEach(productItem => {
      productItem.addEventListener('click', function () {
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const docHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercentAtClick = Math.floor((scrollTop / docHeight) * 100);
          const productItemName = productItem.getAttribute("data-title") || "Unknown Trend";
          const product_name = productItem.getAttribute("data-name") || "Unknown Product";
          const product_price = productItem.getAttribute("data-price") || "N/A";
          const product_category = productItem.getAttribute("data-category") || "Uncategorized";
          const product_id = productItem.getAttribute("data-product-id") || "Uncategorized"; 
          const href = productItem.getAttribute('href') || '';
          window.dataLayer.push({ // Done as per data layer
              event: "PRODUCT_CLICK",
              page_url: href,
              click_text: productItemName,
              product_name:product_name,
              product_id:product_id,
              product_category:product_category,
              product_price:product_price,
              page_path: window.location.pathname,
              page_location: window.location.href,
              page_referrer: document.referrer || "direct",
              locale: navigator.language || "EN",
              device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
              utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
              timestamp: new Date().toISOString(),
          });
           if (maxScroll > 2) {
              window.dataLayer.push({ // Done as per data layer
              event: "scrollDepth", 
              page_path: window.location.pathname,
              page_location: window.location.href,
              page_referrer: document.referrer || "direct",
              locale: navigator.language || "EN",
              device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
              utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
              timestamp: new Date().toISOString(),
              maxScrollPercent: scrollPercentAtClick,
              ...(product_name && { product_name: product_name }),
              ...(product_category && { product_category: product_category }),
              ...(product_price && { product_price: product_price })
          });
        }
      });
  });
  // add to cart Click
  const add_to_Cart_btn = document.querySelector('button[data-add-to-cart]');
  if (!add_to_Cart_btn) return;
  add_to_Cart_btn.addEventListener('click', function () {
      const variantInput = document.querySelector('input[name="variant_id"]');
      const variantId = variantInput ? variantInput.value : "N/A";
      window.dataLayer.push({ // done as per data layer
          event: "ADD_TO_CART_CLICK",
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price }),
          quantity: 1,
          variant_id: variantId,
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          locale: navigator.language || "EN",
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
      });
  });
  const product_info = document.querySelector('.product__wrapper .mob_accordian .show_hide_more_info');
  if (product_info) {
      product_info.addEventListener('click', function () {
          const productInfoText = product_info.textContent.trim();
          window.dataLayer.push({  // new Devloped 
              event: "PRODUCT_INFORMATION_CLICK",
              click_text: productInfoText,
              page_path: window.location.pathname,
              page_location: window.location.href,
              page_referrer: document.referrer || "direct",
              locale: navigator.language || "EN",
              device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
              utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
              timestamp: new Date().toISOString(),
              ...(product_name && { product_name: product_name }),
              ...(product_category && { product_category: product_category }),
              ...(product_price && { product_price: product_price })
          });
      });
  }
  document.querySelectorAll(".product__wrapper .accordion , .product-accordion .accordion").forEach(productInfoAccordion => {
    productInfoAccordion.addEventListener('click', function (e) {
      const summary = productInfoAccordion.querySelector('summary');
      const accordionBody = productInfoAccordion.querySelector('.accordion__body');
      let clickedText = "Unknown";
      if (summary && summary.contains(e.target)) {
        clickedText = summary.textContent.trim();
      } else if (accordionBody && accordionBody.contains(e.target)) {
        clickedText = e.target.textContent.trim() || accordionBody.textContent.trim();
      }     
      window.dataLayer.push({
        event: "PRODUCT_INFORMATION_ACCORDION_CLICK",
        click_text: clickedText,
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        locale: navigator.language || "EN",
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        ...(product_name && { product_name: product_name }),
        ...(product_category && { product_category: product_category }),
        ...(product_price && { product_price: product_price })
      });
    });
  });
  // pdp video event tracking
  const videos = document.querySelectorAll('.mobile-product-video video , video');
  videos.forEach(function (video) {
    let playStartTime = null;
    let hasScrolledOutWhilePlaying = false;
    let userInteracted = false;
    const getCommonData = () => ({
      page_path: window.location.pathname,
      page_location: window.location.href,
      videoSrc: video.currentSrc,
      videoType: 'mobile',
      page_referrer: document.referrer || "direct",
      locale: navigator.language || "EN",
      device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
      utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
      timestamp: new Date().toISOString(),
      ...(product_name && { product_name: product_name }),
      ...(product_category && { product_category: product_category }),
      ...(product_price && { product_price: product_price })
    });
    const sendPlayProgressAndControlClick = (action) => {
      const currentTime = parseInt(video.currentTime, 10);
      window.dataLayer.push({ // Done as per data layer
        event: 'videoPlayProgress',
        videoTime: currentTime,
        ...getCommonData()
      });
      window.dataLayer.push({ // Done as per data layer
        event: 'videoControlClick',
        action: action,
        ...getCommonData()
      });
    };
    const sendWatchedBeforeScrollEvent = (watchedTime) => {
      window.dataLayer.push({ // Done as per data layer
        event: 'videoWatchedBeforeScroll',
        // videoTime: Math.floor(watchedTime),
          videoTime: parseInt(watchedTime,10),
        ...getCommonData()
      });
    };
    // Detect any click or touch as interaction
    const setUserInteraction = () => {
      userInteracted = true;
    };
    video.addEventListener('click', setUserInteraction);
    video.addEventListener('touchstart', setUserInteraction);
    video.addEventListener('play', function () {
      playStartTime = Date.now();
      hasScrolledOutWhilePlaying = false;
      if (userInteracted) {
        sendPlayProgressAndControlClick('play');
      }
    });
    video.addEventListener('pause', function () {
      if (userInteracted) {
        sendPlayProgressAndControlClick('pause');
      }
      playStartTime = null;
    });
    video.addEventListener('volumechange', function () {
      if (userInteracted) {
        const action = video.muted ? 'mute' : 'unmute';
        sendPlayProgressAndControlClick(action);
      }
    });
    video.addEventListener('fullscreenchange', function () {
      if (userInteracted) {
        sendPlayProgressAndControlClick('fullscreen');
      }
    });
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const isVisible = entry.isIntersecting;
          if (!isVisible && !video.paused && playStartTime && !hasScrolledOutWhilePlaying) {
            const watchedTime = (Date.now() - playStartTime) / 1000;
            sendWatchedBeforeScrollEvent(watchedTime);
            hasScrolledOutWhilePlaying = true;
          }

          if (isVisible) {
            hasScrolledOutWhilePlaying = false;
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(video);
  });
  // pdp review scroll event track
  const $ = window.jQuery;
  if (!$ || typeof $.fn.slick !== "function") {
      console.warn("jQuery or Slick not loaded");
      return;
  }
  const $slider = $(".main_cst_review");
  if ($slider.length) {
      let currantSlideIndex = 0;
      let debounceTimer = null;
      $slider.on("afterChange", function (event, slick, currentSlide) {
      const $currentSlide = $(slick.$slides.get(currentSlide));
      const index = parseInt($currentSlide.attr("data-slick-index"), 10) || 0;
      currantSlideIndex = Math.max(currantSlideIndex, index);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
          window.dataLayer.push({ // Done as per data layer
          event: "reviewSliderView",
          max_slide_count: currantSlideIndex,
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_referrer: document.referrer || "direct",
          locale: navigator.language || "EN",
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price })
          });
          currantSlideIndex = 0;
      }, 1500); // Change this value if you want a longer/shorter delay
      });
  } 
  // pdp main slider track
  function sendSlideScrollEvent(maxSlideCount) {
      window.dataLayer.push({ // Done as per data layer
        event: 'product_image_slide',
        max_slide_count: maxSlideCount,
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        locale: navigator.language || "EN",
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        ...(product_name && { product_name: product_name }),
        ...(product_category && { product_category: product_category }),
        ...(product_price && { product_price: product_price })
      });
  }
  function initSlickObserver() {
      const slickTrack = document.querySelector('.slick-track');
      if (!slickTrack) {
        setTimeout(initSlickObserver, 500); // Retry
        return;
      }
      let sessionMaxSlide = 0;
      let debounceTimer = null;
      const triggerSlideEvent = () => {
        if (sessionMaxSlide > 0) {
          sendSlideScrollEvent(sessionMaxSlide);
          sessionMaxSlide = 0; // reset for next session
        }
      };
      const observer = new MutationObserver(() => {
        const activeSlide = document.querySelector('.product__slide.slick-current');
        if (!activeSlide) return;
        const currentIndex = parseInt(activeSlide.getAttribute('data-slick-index'), 10);
        if (!isNaN(currentIndex)) {
          sessionMaxSlide = Math.max(sessionMaxSlide, currentIndex);
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(triggerSlideEvent, 2000);
        }
      });
      observer.observe(slickTrack, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      }); 
      console.log("✅ Slick observer initialized.");
  }
  initSlickObserver();
  // *** pdp end events *** //
  // search event need to check
  document.querySelectorAll('.predictive-search__products__list  .predictive-search__grid-item a').forEach(function (el) {
  el.addEventListener('click', function (e) {
    e.preventDefault();
    const product_name = el.getAttribute('data-product-name');
    const product_category = el.getAttribute('data-product-category');
    const product_price = el.getAttribute('data-product-price');
    setTimeout(function(){
      window.dataLayer.push({
        event: "campaignProductclick",
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        locale: navigator.language || "EN",
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        ...(product_name && { product_name }),
        ...(product_category && { product_category }),
        ...(product_price && { product_price })
      });
    },1000);
    
  });
});

  // the letter campaign page video
  const campaign_videos = document.querySelectorAll('.campaign_desk_video, .campaign_mob_video');
  campaign_videos.forEach(function (video) {
    let playTime = 0;
    let trackingIntervals = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]; // seconds
    let trackedTimes = [];
    // Track play time intervals
    video.addEventListener('timeupdate', function () {
      const currentTime = Math.floor(video.currentTime);
      if (trackingIntervals.includes(currentTime) && !trackedTimes.includes(currentTime)) {
        trackedTimes.push(currentTime);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ // Done as per data layer
          event: 'videoPlayProgress',
          videoTime: currentTime,
          videoSrc: video.currentSrc,
          videoType: video.classList.contains('campaign_mob_video') ? 'mobile' : 'desktop',
          page_referrer: document.referrer || "direct",
          locale: navigator.language || "EN",
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          page_location: window.location.href,
          page_path: window.location.pathname,
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price })
        });
      }
    });
    // Track control clicks
    ['play', 'pause', 'volumechange', 'fullscreenchange'].forEach(function (eventType) {
      video.addEventListener(eventType, function (e) {
        let action = eventType;
        // Make it readable
        if (eventType === 'volumechange') {
          action = video.muted ? 'mute' : 'unmute';
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ // Done as per data layer
          event: 'videoControlClick',
          action: action,
          videoSrc: video.currentSrc,
          videoType: video.classList.contains('campaign_mob_video') ? 'mobile' : 'desktop',
          page_referrer: document.referrer || "direct",
          locale: navigator.language || "EN",
          device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
          utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
          timestamp: new Date().toISOString(),
          page_location: window.location.href,
          page_path: window.location.pathname,
          ...(product_name && { product_name: product_name }),
          ...(product_category && { product_category: product_category }),
          ...(product_price && { product_price: product_price })
        });
      });
    });
  });
  // collection_Click
 document.querySelectorAll("a[href*='/collections']").forEach(collectionLink => {
  collectionLink.addEventListener('click', function () {
    const href = collectionLink.getAttribute('href');
    // Check if it contains 'collections' but NOT 'products'
    if (href.includes('/collections') && !href.includes('/products')) {
      const match = href.match(/\/collections\/([^\/?#]+)/);
      let collectionName = "";
      if (match && match[1]) {
        collectionName = match[1]
          .replace(/-/g, ' ')                        // Replace dashes with spaces
          .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
      }
      window.dataLayer.push({
        event: "COLLECTION_CLICK",
        locale: navigator.language || "EN",
        utm: new URLSearchParams(window.location.search).get("utm_source") || "direct",
        timestamp: new Date().toISOString(),
        device_category: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_referrer: document.referrer || "direct",
        collection_name:collectionName,
        ...(product_name && { product_name: product_name }),
        ...(product_category && { product_category: product_category }),
        ...(product_price && { product_price: product_price })
      });
    }
  });
});

 
//document ready end
});

